// apps/web/src/components/common/PaginationBar.tsx
import React from 'react';
import {
  Box,
  Pagination,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  SelectChangeEvent,
  useMediaQuery,
  useTheme,
} from '@mui/material';

interface PaginationBarProps {
  count: number; // общее количество записей
  page: number; // текущая страница (начиная с 1)
  rowsPerPage: number; // количество записей на странице
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  rowsPerPageOptions?: number[];
  labelRowsPerPage?: string;
}

const DEFAULT_OPTIONS = [10, 20, 50, 100];

export const PaginationBar: React.FC<PaginationBarProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = DEFAULT_OPTIONS,
  labelRowsPerPage = 'Строк на странице',
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const totalPages = Math.ceil(count / rowsPerPage);

  const handlePageChange = (_: React.ChangeEvent<unknown>, value: number) => {
    onPageChange(value);
  };

  const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
    const newRowsPerPage = Number(event.target.value);
    onRowsPerPageChange(newRowsPerPage);
    onPageChange(1); // сброс на первую страницу
  };

  // Всегда показываем блок, даже если записей мало, чтобы можно было изменить количество на странице
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mt: 2,
        p: 1,
      }}
    >
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel id="rows-per-page-label">{labelRowsPerPage}</InputLabel>
        <Select
          labelId="rows-per-page-label"
          value={rowsPerPage}
          label={labelRowsPerPage}
          onChange={handleRowsPerPageChange}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {totalPages > 1 && (
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
          size={isMobile ? 'small' : 'medium'}
          siblingCount={isMobile ? 0 : 1}
          boundaryCount={isMobile ? 1 : 1}
          showFirstButton={!isMobile}
          showLastButton={!isMobile}
        />
      )}
    </Box>
  );
};
